import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';
import { capitalise } from 'utils';

import { LENDER_RESPONSE_TIMES } from './constants';

interface ReferredHook {
  isLoading: boolean;
  showButton: boolean;
  link?: string;
  provider: string;
  responseTime: string;
}

export default function useReferred(): ReferredHook {
  const { isLoading, credit, provider } = useStatusContext();

  const link = useMemo(() => {
    if (!credit) return undefined;
    return credit?.xref;
  }, [credit]);

  const responseTime = useMemo(() => {
    if (!provider) return LENDER_RESPONSE_TIMES.default;
    if (provider === 'propensio') return LENDER_RESPONSE_TIMES.propensio;
    return LENDER_RESPONSE_TIMES.default;
  }, [provider]);

  const showButton = useMemo(
    () => Boolean(link && provider === 'etika'),
    [link, provider],
  );

  return {
    isLoading,
    showButton,
    link,
    provider: provider ? capitalise(provider) : '',
    responseTime,
  };
}
